import { MenuHR, MenuEN } from '@/assets/images';

export default {
  image: {
    hr: MenuHR,
    en: MenuEN
  },

  campaign: {
    ar: 'عن الحملة',
    en: 'About the campaign'
  },

  onboarding: {
    ar: 'كيف يعمل',
    en: 'How it works'
  },

  home: {
    ar: 'العودة إلى الصفحة الرئيسية',
    en: 'Go to Homepage'
  },

  termsLink: {
    ar: 'https://storage.googleapis.com/media-mcd-hr-campaign-prod/Terms/Terms%20and%20conditions%20golden%20getaway%20final%20TBWA.pdf?openOutsideMcd=true',
    en: 'https://storage.googleapis.com/media-mcd-hr-campaign-prod/Terms/Terms%20and%20conditions%20golden%20getaway%20final%20TBWA.pdf?openOutsideMcd=true'
  },

  terms: {
    ar: 'الشروط والأحكام',
    en: 'Terms & Conditions'
  }
};
